import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  searchRequest: ['content'],
  searchSuccess: ['data'],
  searchFailed: ['error'],

  searchInfosRequest: ['products'],
  searchInfosSuccess: ['products'],
  searchInfosFailed: ['error'],

  clearSearch: [''],

  searchParamRequest: ['param', 'dataPreLoaded', 'extraParams'],
  searchParamSuccess: ['data'],
  searchParamError: ['error'],

  setSearchParamsRequest: ['params'],
});

const INITIAL_STATE = Immutable({
  products: [],
  suggestions: [],
  searchSuggestions: [],
  totalProducts: 0,
  error: {},
  param: {},
  isLoading: false,
});

const searchRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const searchFailed = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const clearSearch = (state = INITIAL_STATE) => state.merge({ products: [], suggestions: [] });

const searchSuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data }).set('isLoading', false);

const searchInfosSuccess = (state = INITIAL_STATE, { products }) => state.replace({ products }).set('isLoading', false);

const searchParamRequest = (state = INITIAL_STATE, { param }) => state.merge({ param });
const searchParamSuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data });
const searchParamError = (state = INITIAL_STATE, { error }) => state.merge({ ...error });

export default createReducer(INITIAL_STATE, {
  [Types.SEARCH_REQUEST]: searchRequest,
  [Types.SEARCH_SUCCESS]: searchSuccess,
  [Types.SEARCH_FAILED]: searchFailed,

  [Types.SEARCH_INFOS_REQUEST]: searchRequest,
  [Types.SEARCH_INFOS_SUCCESS]: searchInfosSuccess,
  [Types.SEARCH_INFOS_FAILED]: searchFailed,

  [Types.CLEAR_SEARCH]: clearSearch,

  [Types.SEARCH_PARAM_REQUEST]: searchParamRequest,
  [Types.SEARCH_PARAM_SUCCESS]: searchParamSuccess,
  [Types.SEARCH_PARAM_ERROR]: searchParamError,
});
